import { fromJS, Map } from 'immutable';
import actionTypes from 'constants/currentUserConstants';

export const initialState = fromJS({
  data: {
    email: '',
    name: '',
    token: '',
    token_valid_until: '',
    account_name: '',
    account_address: {},
  },
  error: null,
  passwordRequired: false,
  isPasswordResetSent: false,
  confirmed: false,
  resent: false,
  emailChecked: false,
  isLoggedIn: false,
  isLoading: false,
});

function data(state, action) {
  switch (action.type) {
    case actionTypes.FETCH_CURRENT_USER_SUCCESS:
      return fromJS(action.payload);
    default:
      return state;
  }
}

function isLoggedIn(state, action) {
  switch (action.type) {
    case actionTypes.AUTHENTICATION_SUCCESS:
      return true;
    case actionTypes.AUTHENTICATION_FAILURE:
      return false;
    default:
      return state;
  }
}

function isLoading(state, action) {
  switch (action.type) {
    case actionTypes.FETCH_CURRENT_USER_REQUEST:
    case actionTypes.AUTHENTICATION_REQUEST:
    case actionTypes.CONFIRMATION_REQUEST:
      return true;
    case actionTypes.FETCH_CURRENT_USER_SUCCESS:
    case actionTypes.FETCH_CURRENT_USER_FAILURE:
    case actionTypes.AUTHENTICATION_FAILURE:
    case actionTypes.AUTHENTICATION_SUCCESS:
    case actionTypes.CONFIRMATION_RESENT:
    case actionTypes.PASSWORD_RESET:
      return false;
    default:
      return state;
  }
}

function isPasswordRequired(state, action) {
  switch (action.type) {
    case actionTypes.EMAIL_CHECKED:
      return action.payload.existing_user;
    default:
      return state;
  }
}

function isConfirmed(state, action) {
  switch (action.type) {
    case actionTypes.EMAIL_CHECKED:
      return action.payload.confirmed;
    default:
      return state;
  }
}

function isResent(state, action) {
  switch (action.type) {
    case actionTypes.CONFIRMATION_RESENT:
      return true;
    case actionTypes.EMAIL_CHANGED:
      return false;
    default:
      return state;
  }
}

function emailChecked(state, action) {
  switch (action.type) {
    case actionTypes.EMAIL_CHECKED:
      return true;
    case actionTypes.EMAIL_CHANGED:
      return false;
    default:
      return state;
  }
}

function isPasswordResetSent(state, action) {
  switch (action.type) {
    case actionTypes.PASSWORD_RESET:
      return true;
    case actionTypes.EMAIL_CHANGED:
      return false;
    default:
      return state;
  }
}

function error(state, action) {
  switch (action.type) {
    case actionTypes.AUTHENTICATION_FAILURE:
      return action.payload;
    case actionTypes.AUTHENTICATION_SUCCESS:
    case actionTypes.AUTHENTICATION_ERROR_RESET:
    case actionTypes.EMAIL_CHANGED:
      return null;
    default:
      return state;
  }
}

const currentUserReducer = (state = initialState, action) => {
  return Map({
    data: data(state.get('data'), action),
    isLoggedIn: isLoggedIn(state.get('isLoggedIn'), action),
    isLoading: isLoading(state.get('isLoading'), action),
    emailChecked: emailChecked(state.get('emailChecked'), action),
    passwordRequired: isPasswordRequired(state.get('passwordRequired'), action),
    isPasswordResetSent: isPasswordResetSent(state.get('isPasswordResetSent'), action),
    confirmed: isConfirmed(state.get('confirmed'), action),
    resent: isResent(state.get('resent'), action),
    error: error(state.get('error'), action),
  });
};

export default currentUserReducer;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/currentUserReducer.js